export default {
  props: {
    small: {
      type: Boolean,
      default: false
    }
  }
};